export const RECEIVE_TAX_REDUCTION_DATA = 'RECEIVE_TAX_REDUCTION_DATA';
